
// A deliberately provider-agnostic seam for gating whole PointView
// panels (IFC/OBJ-model + everything built on it, own GIS/LER data)
// behind a real rights/licensing system - one is not wired into this
// app yet ("rettighedsstyringen kommer fra et eksisterende modul du
// ikke har set endnu" per the spec conversation), so this file is
// deliberately the smallest thing that lets that integration happen
// later without touching every call site again:
//
//   - every module defaults to enabled, so nothing regresses today;
//   - a future rights module registers ONE function via
//     registerProvider() (or calls setEnabled() directly, if it
//     prefers to push state rather than be asked) from wherever it
//     boots, before or after PointView's own boot sequence - order
//     doesn't matter, isEnabled() is only ever consulted at the point
//     a panel would be built;
//   - onChange() exists for a future rights module that can change
//     mid-session (e.g. sign-in/out) to tell PointView to rebuild its
//     sidebar - nothing in PointView calls it today (the sidebar is
//     built once at boot), so it is a no-op until something does.
//
// index.html only ever calls isEnabled(moduleId) before creating a
// gated section (see initGatedSections there) - it has no other
// dependency on how rights are actually decided.

let provider = null; // (moduleId) => boolean | undefined
let overrides = new Map(); // moduleId -> boolean, takes precedence over provider
let changeListeners = [];

function notify(){
	for(let fn of changeListeners){
		fn();
	}
}

export const PVModules = {
	// moduleId -> boolean | undefined. Returning undefined (or
	// anything non-boolean) for a moduleId it doesn't know about
	// falls through to the default-allow below, rather than needing
	// the provider to enumerate every module PointView might ever add.
	registerProvider(fn){
		provider = fn;
		notify();
	},

	// Direct override, independent of (and checked before) the
	// provider - handy for the future module if it prefers to push
	// updates rather than be queried, and for local testing.
	setEnabled(moduleId, enabled){
		overrides.set(moduleId, !!enabled);
		notify();
	},

	clearOverride(moduleId){
		overrides.delete(moduleId);
		notify();
	},

	isEnabled(moduleId){
		if(overrides.has(moduleId)){
			return overrides.get(moduleId);
		}
		if(provider){
			let result = provider(moduleId);
			if(typeof result === "boolean"){
				return result;
			}
		}
		return true;
	},

	onChange(fn){
		changeListeners.push(fn);
	},
};
